import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useTheme } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MenuIcon from '@material-ui/icons/Menu';
import DashTabs from 'components/DashTabs';
import NavBarLogin from 'components/NavBarLogin';
import NotificationButton from 'components/Notifications';
import { Captions } from 'components/Typography';
import { StyledLink } from 'containers/MRhDashboard/services/styles';
import Logo from 'containers/NavBarDashboard/Logo';
import messages from 'containers/NavBarDashboard/messages';
import {
  ActionButtonsGrid,
  Container,
  IconContainer,
  StyledCloseIcon,
  StyledGrid,
  StyledGridNav,
  StyledImg,
  StyledImgIcon,
  StyledMenu,
  StyledLanguageButton,
  StyledMenuItem,
  StyledMenuSettings,
  StyledModal,
  StyledOrangeButton,
  StyledPrimaryButton,
  StyledProfileSettings,
  StyledShortBody,
  StyledShortText,
  StyledSmallSectionHeader,
} from 'containers/NavBarDashboard/styles';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { isReverse, translate } from 'helpers/intl';
import { pushTo } from 'helpers/routes';
import { AssuranceIcon } from 'images';
import { get, upperCase } from 'lodash';
import React, { ChangeEvent } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PAGES from 'routes/pages';
import { openAddNewContractModal } from 'store/contract/actions';
import { setSelectedTab, SetTabs } from 'store/global/actions';
import {
  getSelectedTabSelector,
  getTabsSelector,
} from 'store/global/selectors';
import { changeLocaleLanguage } from 'store/LanguageProvider/actions';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { logout } from 'store/user/actions';
import { getIsGetUserInfoLoading } from 'store/user/selectors';
import { contactAuto, contactMrh } from 'utils/globalConst';
import HealthCallCenter from './HealthCallCenter';

const NavBarDashboard = (props: {
  roles?: [];
  SetTabs: Function;
  intl: IntlShape;
  openAddNewContractModal: Function;
  setSelectedTab: Function;
  isLoading: boolean;
  selectedTab: string;
  logout: Function;
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  /* istanbul ignore next */
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [modalMenuSettingsisOpen, setModalMenuSettingsisOpen] = React.useState<
    boolean
  >(false);
  /* istanbul ignore next */
  const handleCloseMenuSettings = () => {
    setModalMenuSettingsisOpen(false);
  };

  const [
    anchorLanguage,
    setAnchorLanguage,
  ] = React.useState<null | HTMLElement>(null);
  const [anchorService, setAnchorService] = React.useState<null | HTMLElement>(
    null,
  );
  const language = useSelector(getLocaleSelector);
  const reverse = isReverse(language);
  const dispatch = useDispatch();

  const handleClickLanguageMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorLanguage(event.currentTarget);
  };

  const handleCloseLanguageMenu = () => {
    setAnchorLanguage(null);
  };
  const handleChangeLanguage = (
    e: ChangeEvent<HTMLInputElement>,
    value: string,
  ) => {
    dispatch(changeLocaleLanguage(value));
    handleCloseLanguageMenu();
  };
  const handleClickServiceMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorService(event.currentTarget);
  };
  /* istanbul ignore next */
  const handleCloseServiceMenu = () => {
    setAnchorService(null);
  };
  const tabsValue = props.roles;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      {props.isLoading ? (
        <> </>
      ) : tabsValue && tabsValue.length > 0 ? (
        <Container container justify="space-between" alignItems="flex-start">
          <Grid item xs={3}>
            <IconContainer>
              <Logo />
            </IconContainer>
          </Grid>

          <Grid item xs={9} sm={9} lg={9}>
            <Grid container>
              <StyledGridNav language={language} item xs={matches ? 2 : 4}>
                {!matches && (
                  <DashTabs
                    items={
                      tabsValue &&
                      tabsValue.map((item: any) => ({
                        label: translate(get(messages, item.type), props),
                        path: item.path,
                      }))
                    }
                    setSelectedTab={props.setSelectedTab}
                  />
                )}
              </StyledGridNav>
              <ActionButtonsGrid item xs={matches ? 12 : 7}>
                {!matches && (
                  <StyledOrangeButton
                    reverse={reverse}
                    variant="contained"
                    onClick={() => props.openAddNewContractModal()}
                  >
                    <img
                      src={AssuranceIcon['AddContractIcon']}
                      alt="add-icon"
                    />
                    {translate(get(messages, 'addContracts'), props)}
                  </StyledOrangeButton>
                )}
                <StyledPrimaryButton
                  data-testid="services"
                  variant="contained"
                  onClick={(e: any) => {
                    handleClickServiceMenu(e);
                    GATracking.event(
                      EVENT_CATEGORIES.AUTO_ACCEUIL,
                      EVENT_ACTION.CLICK,
                      'Header_Assisatnce_Picto Tel 3434',
                    );
                  }}
                >
                  <img
                    src={get(AssuranceIcon, 'telInfo')}
                    alt="tel-info-icon"
                  />
                </StyledPrimaryButton>
                <NotificationButton />
                {!matches && (
                  <StyledLanguageButton
                    onClick={(e: any) => {
                      handleClickLanguageMenu(e);
                      GATracking.event(
                        EVENT_CATEGORIES.MRH_ACCUEIL,
                        EVENT_ACTION.CLICK,
                        'Header_Assistance_Picto tel _ 0522 480 480',
                      );
                    }}
                    variant="contained"
                    aria-controls="language-menu"
                  >
                    <Tooltip
                      title={translate(get(messages, 'languages'), props)}
                    >
                      <Grid container alignItems="center">
                        <img
                          src={get(AssuranceIcon, 'globe')}
                          alt="globe-icon"
                        />
                        <Captions>{upperCase(language)}</Captions>
                        <img
                          src={get(AssuranceIcon, 'caretDown')}
                          alt="caret-down-icon"
                        />
                      </Grid>
                    </Tooltip>
                  </StyledLanguageButton>
                )}
                <StyledProfileSettings
                  data-testid="setting-account"
                  onClick={handleClick}
                  variant="contained"
                >
                  <Tooltip title={translate(get(messages, 'myAccount'), props)}>
                    <Grid container alignItems="center">
                      <img
                        src={get(AssuranceIcon, 'profilSetting')}
                        alt="profile-setting-icon"
                      />
                      <img
                        src={get(AssuranceIcon, 'caretDown')}
                        alt="caret-down-icon"
                      />
                    </Grid>
                  </Tooltip>
                </StyledProfileSettings>
                {matches && (
                  <StyledMenuSettings
                    onClick={
                      /* istanbul ignore next */
                      () => setModalMenuSettingsisOpen(true)
                    }
                    variant="contained"
                  >
                    <Tooltip
                      title={translate(get(messages, 'myAccount'), props)}
                    >
                      <MenuIcon />
                    </Tooltip>
                  </StyledMenuSettings>
                )}
                <HealthCallCenter
                  anchorService={anchorService}
                  handleCloseServiceMenu={handleCloseServiceMenu}
                />
                {window.location.pathname.slice(1) ===
                  PAGES.AUTO_DETAILS.substring(1) ||
                window.location.pathname.slice(1) ===
                  PAGES.AUTODASHBOARD.substring(1) ? (
                  <StyledMenu
                    id="Service-menu"
                    anchorEl={anchorService}
                    open={Boolean(anchorService)}
                    onClose={handleCloseServiceMenu}
                    elevation={1}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <StyledMenuItem>
                      <Grid container spacing={1}>
                        <Grid item xs={2}>
                          <StyledImgIcon
                            src={get(AssuranceIcon, 'serviceAuto')}
                            alt="auto"
                          />
                        </Grid>
                        <Grid item xs={10}>
                          <Grid container direction="column">
                            <Grid item xs={3}>
                              <StyledShortText
                                reverse={reverse}
                                color="#162952"
                                weight="100"
                              >
                                {translate(
                                  get(messages, 'service_assitance'),
                                  props,
                                )}
                              </StyledShortText>
                            </Grid>
                            <StyledGrid item xs={12}>
                              <StyledLink href={`tel:${contactAuto.service}`}>
                                <strong>
                                  <StyledShortBody color="#003FCB" weight="900">
                                    {translate(get(messages, 'applez'), props)}
                                  </StyledShortBody>
                                </strong>
                              </StyledLink>
                            </StyledGrid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </StyledMenuItem>
                  </StyledMenu>
                ) : window.location.pathname.slice(1) ===
                    PAGES.MRHDASHBOARD.substring(1) ||
                  window.location.pathname.slice(1) ===
                    PAGES.MRH_DETAILS.substring(1) ? (
                  <StyledMenu
                    id="Service-menu"
                    anchorEl={anchorService}
                    open={Boolean(anchorService)}
                    onClose={handleCloseServiceMenu}
                    elevation={1}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <StyledMenuItem>
                      <Grid container spacing={1}>
                        <Grid item xs={2}>
                          <StyledImgIcon
                            src={get(AssuranceIcon, 'serviceMrh')}
                            alt="auto"
                          />
                        </Grid>
                        <Grid item xs={10}>
                          <Grid container direction="column">
                            <Grid item xs={3}>
                              <StyledShortText
                                reverse={reverse}
                                color="#6D2C8F"
                                weight="100"
                              >
                                {translate(
                                  get(messages, 'service_assitance'),
                                  props,
                                )}
                              </StyledShortText>
                            </Grid>
                            <StyledGrid item xs={12}>
                              <StyledLink href={`tel:${contactMrh.serviceFr}`}>
                                <StyledShortBody color="#6D2C8F" weight="900">
                                  {translate(
                                    get(messages, 'appelezMrh'),
                                    props,
                                  )}
                                </StyledShortBody>
                              </StyledLink>
                            </StyledGrid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </StyledMenuItem>
                  </StyledMenu>
                ) : (
                  <></>
                )}
                <StyledMenu
                  id="language-menu"
                  anchorEl={anchorLanguage}
                  open={Boolean(anchorLanguage)}
                  onClose={handleCloseLanguageMenu}
                  elevation={0}
                  getContentAnchorEl={null}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="language-radio-group"
                      name="language"
                      value={language}
                      data-testid="language-radio-group"
                      onChange={handleChangeLanguage}
                    >
                      <MenuItem>
                        <FormControlLabel
                          value={LANGUAGES.FR}
                          control={<Radio />}
                          label={translate(get(messages, 'french'), props)}
                        />
                      </MenuItem>
                      <MenuItem>
                        <FormControlLabel
                          value={LANGUAGES.AR}
                          control={<Radio />}
                          label={translate(get(messages, 'arabic'), props)}
                        />
                      </MenuItem>
                    </RadioGroup>
                  </FormControl>
                </StyledMenu>
                {matches && (
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                  >
                    <StyledModal
                      open={modalMenuSettingsisOpen}
                      onClose={
                        /* istanbul ignore next */
                        () => handleCloseMenuSettings()
                      }
                      disableBackdropClick={false}
                    >
                      <>
                        <Grid
                          container
                          direction="row-reverse"
                          style={{ padding: '0 24px' }}
                        >
                          <Grid item>
                            <StyledCloseIcon
                              onClick={
                                /* istanbul ignore next */
                                () => handleCloseMenuSettings()
                              }
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          direction="column"
                          justify="space-between"
                          alignItems="center"
                        >
                          <Grid item>
                            <DashTabs
                              items={
                                tabsValue &&
                                tabsValue.map(
                                  /* istanbul ignore next */
                                  (item: any) => ({
                                    label: translate(
                                      get(messages, item.type),
                                      props,
                                    ),
                                    path: item.path,
                                  }),
                                )
                              }
                              setSelectedTab={props.setSelectedTab}
                              handleCloseMenuSettings={
                                /* istanbul ignore next */
                                () => handleCloseMenuSettings()
                              }
                            />
                          </Grid>

                          <Grid
                            item
                            direction="column"
                            justify="flex-end"
                            alignItems="center"
                          >
                            <Grid
                              container
                              justify="center"
                              alignItems="center"
                            >
                              <Grid item>
                                <StyledSmallSectionHeader>
                                  {translate(get(messages, 'language'), props)}
                                </StyledSmallSectionHeader>
                              </Grid>
                              <Grid item>
                                <FormControl component="fieldset">
                                  <RadioGroup
                                    aria-label="language-radio-group"
                                    name="language"
                                    value={language}
                                    data-testid="language-radio-group"
                                    onChange={handleChangeLanguage}
                                    onClick={
                                      /* istanbul ignore next */
                                      () => handleCloseMenuSettings()
                                    }
                                  >
                                    <MenuItem>
                                      <FormControlLabel
                                        value={LANGUAGES.FR}
                                        control={<Radio />}
                                        label={upperCase(LANGUAGES.FR)}
                                      />

                                      <FormControlLabel
                                        value={LANGUAGES.AR}
                                        control={<Radio />}
                                        label={upperCase(LANGUAGES.AR)}
                                      />
                                    </MenuItem>
                                  </RadioGroup>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          direction="column"
                          justify="space-between"
                          alignItems="center"
                        >
                          <StyledOrangeButton
                            reverse={reverse}
                            variant="contained"
                            onClick={
                              /* istanbul ignore next */
                              () => {
                                props.openAddNewContractModal();
                                handleCloseMenuSettings();
                              }
                            }
                          >
                            <img
                              src={AssuranceIcon['AddContractIcon']}
                              alt="add-icon"
                            />
                            {translate(get(messages, 'addContracts'), props)}
                          </StyledOrangeButton>
                        </Grid>
                      </>
                    </StyledModal>
                  </Grid>
                )}
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  elevation={0}
                  getContentAnchorEl={null}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <GaClickHOC
                    label="Paramètres du compte"
                    category={EVENT_CATEGORIES.MY_ACCOUNT}
                  >
                    <MenuItem
                      data-testid="account"
                      onClick={
                        /* istanbul ignore next */ () => {
                          pushTo(PAGES.MY_ACCOUNT);
                          handleClose();
                        }
                      }
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={2}>
                          <StyledImg
                            src={get(AssuranceIcon, 'settings')}
                            alt="setting-icon"
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <StyledShortBody color="#162952">
                            {translate(get(messages, 'settingAccount'), props)}
                          </StyledShortBody>
                        </Grid>
                      </Grid>
                    </MenuItem>
                  </GaClickHOC>

                  <GaClickHOC
                    label="Se déconnecter"
                    category={EVENT_CATEGORIES.MY_ACCOUNT}
                  >
                    <MenuItem
                      data-testid="deconnexion"
                      onClick={
                        /* istanbul ignore next */ () => {
                          handleClose();
                          props.logout();
                        }
                      }
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={2}>
                          <StyledImg
                            src={get(AssuranceIcon, 'logOut')}
                            alt="setting-icon"
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <StyledShortBody color="#F5523C">
                            {translate(get(messages, 'deconnexion'), props)}
                          </StyledShortBody>
                        </Grid>
                      </Grid>
                    </MenuItem>
                  </GaClickHOC>
                </Menu>
              </ActionButtonsGrid>
            </Grid>
          </Grid>
        </Container>
      ) : (
        <NavBarLogin />
      )}
    </>
  );
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    roles: any;
    isLoading: boolean;
    selectedTab: string;
  }
>({
  roles: getTabsSelector,
  selectedTab: getSelectedTabSelector,
  isLoading: getIsGetUserInfoLoading,
});
const mapDispatchToProps = {
  SetTabs,
  openAddNewContractModal,
  setSelectedTab,
  logout,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(NavBarDashboard));

const TestNavBarDashboard = injectIntl(NavBarDashboard);

export { TestNavBarDashboard };
